import styled from "styled-components";

const StyledLandingPage = styled.div`
  height: 100vh;
  width: 100vw;
  font-family: ${(props) => props.theme.lato};
  position: relative;

  .suburbDiv {
    width: 100%;
    /* margin: 0 20px; */

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    height: calc(100% - 200px);
    padding: 20px;
    padding-top: 34px;
  }

  .textBlurbs {
    margin-bottom: 32px;
  }

  .topText {
    padding: 0 15px;
    color: white;
    font-size: 42px;
    text-transform: uppercase;
    margin: 0;
    display: flex;
    flex-direction: column;
    padding-top: 100px;
    @media (max-width: 1024px) {
      font-size: 44px;
    }
  }
  .bubbles {
    display: flex;
    flex-direction: row;
    margin: 5px;
  }
  .bubble {
    width: 8px;
    height: 8px;
    margin: 0 8px;
    border-radius: 50%;
    background-color: #ededed;
    border: 1px solid #d1d1d1;
  }
  .bottomText {
    padding: 15px;
    color: white;
    font-size: 16px;

    /* max-width: 450px; */
    @media (max-width: 1024px) {
      font-size: 20px;
    }
  }
  .suburbs {
    width: 750px;
    height: 750px;
    @media (max-width: 1024px) {
      width: 550px;
      height: 550px;
    }
  }
  .fromMomentum {
    color: white;
    font-size: 22px;
    line-height: 1.5;
    margin: 15px 0 0 15px;
  }
  .bottomDiv {
    display: flex;
    width: 85%;
    margin: 0 auto;
    justify-content: space-evenly;
  }
  .bottomButtonLeft {
    background-color: #2394f5;
    padding: 15px 5px;
    color: white;
    border-radius: 42px;
    width: 225px;
    border: none;
    font-size: 26px;
    margin: 0 15px;
  }
  .logo {
    width: 75px;
    height: 75px;
  }
  .momentumLogo {
    position: absolute;
    bottom: 130px;
    right: 30px;
  }
  .bottomButtonRight {
    margin: 0 15px;
    background-color: #dfe0e2;
    padding: 15px 5px;
    color: #8d8b8b;
    border-radius: 15px;
    border-radius: 42px;
    width: 225px;
    border: none;
    font-size: 26px;
  }
  .palm {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    transform: rotateY(180deg);
    object-position: right;
  }
  .formContainer {
    /* overflow: hidden; */
    flex-direction: row;
    flex-wrap: wrap;
    width: 450px;
    margin: 20px;
    /* height: 400px; */
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .referral {
    color: #6f6e6e;

    font-size: 26px;
    margin: 10px;
    text-transform: uppercase;
  }
  .greyInputs {
    width: 400px;

    border: 1px solid #d1d1d1;
    border-radius: 6px;
    padding: 6px 8px;
    &:focus {
      outline: none;
    }
    margin: 5px;
    color: #969696;
    background-color: #ededed;
  }

  .small {
    width: 196px;
  }
  .submitButton {
    color: white;
    background-color: #336699;
    border-radius: 2px;
    font-size: 18px;
    margin: 10px;
    padding: 8px 12px;
    font-family: ${(props) => props.theme.lato};
    border: none;
    width: 90%;

    :hover {
      cursor: pointer;
    }
  }

  .copy-1 {
    display: grid;
    grid-gap: 10px;
    margin-bottom: 16px;
  }

  .copy-2 {
    display: grid;
    grid-gap: 10px;
  }
`;

export default StyledLandingPage;
